import { getNoBidClientStyle } from 'utils/helpers'
import s from './ParentCellRenderer.scss'

const ParentCellRenderer = ({ data }) => {
  if (!data || !data.parent) return null
  const { id, name, noBid } = data.parent

  return (
    <a className={s.link} style={getNoBidClientStyle(noBid)} href={`/companies/${id}`}>
      {name}
    </a>
  )
}

export default ParentCellRenderer
